export const NeoAvatar = ({ size = 20, className = "" }) => (
  <img src={size > 48 ? "/neo-avatar.png" : "/neo-avatar-96.png"} alt="Néo" width={size} height={size} className={`rounded-full shrink-0 select-none ${className}`} draggable={false} data-testid="neo-avatar" />
);
